import { Icon, IconsMap } from '@nx-frontend/shared/ui/icon';

interface CitationIconProps {
  docType?: string;
}

export const CitationIcon: React.FC<CitationIconProps> = ({ docType }) => {
  const getIcon = (docType?: string) => {
    switch (docType) {
      case 'page':
        return IconsMap.NOTE;
      case 'guide':
        return IconsMap.BOOK;
      default:
        return IconsMap.LINK_1;
    }
  };

  return (
    <button className="flex items-center justify-center w-4 h-4 bg-[#7DB0A8] rounded p-0.5 cursor-pointer transition-colors duration-200 ease-in-out hover:bg-cyan-700 group-hover:bg-cyan-700">
      <Icon icon={getIcon(docType)} className="w-3 text-white" />
    </button>
  );
};
